import React from 'react';
import { NavLink, Outlet, useLocation, Navigate } from 'react-router-dom';
import { Box, Tab, Tabs, Typography, CircularProgress } from '@mui/material';
import { useTenantAuth } from '../context/TenantAuthContext';

export default function TenantBillingLayout() {
  const location = useLocation();
  const { ready, hasPermission } = useTenantAuth();
  const tab = location.pathname.includes('/billing/invoices') ? 'invoices' : 'profile';

  if (!ready) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }
  if (!hasPermission('tenant.billing.view')) {
    return <Navigate to="/tenant" replace />;
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Billing
      </Typography>
      <Tabs value={tab} sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tab
          label="Billing contact"
          value="profile"
          component={NavLink}
          to="/tenant/billing"
          end
          sx={{ '&.active': { fontWeight: 600 } }}
        />
        <Tab
          label="Invoices"
          value="invoices"
          component={NavLink}
          to="/tenant/billing/invoices"
          sx={{ '&.active': { fontWeight: 600 } }}
        />
      </Tabs>
      <Outlet />
    </Box>
  );
}
